import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '@bitcoin-portal/bitcoincom-pkg-components/dist/Modal';
import H2 from '@bitcoin-portal/bitcoincom-pkg-components/dist/H2';
import H3 from '@bitcoin-portal/bitcoincom-pkg-components/dist/H3';
import QRCode from '@bitcoin-portal/bitcoincom-pkg-components/dist/QRCode';
import Paragraph from '@bitcoin-portal/bitcoincom-pkg-components/dist/Paragraph';
import WalletRow from './WalletRow';
import { Disclaimer, ModalWrapper, QRWrapper } from './styled';

const Wallets = ({ wallets }) => {
  const [mnemonic, setMnemonic] = useState('');
  const modalRef = useRef();

  const handleOpenModal = data => {
    setMnemonic(data);
    if (modalRef.current) modalRef.current.open();
  };

  return (
    <>
      {wallets.wallets.length > 0 && (
        <div style={{ marginTop: 32 }}>
          <H2>Active Wallets</H2>
          {wallets.wallets.map(w => (
            <WalletRow
              key={w.walletId}
              wallet={w}
              openModal={handleOpenModal}
            />
          ))}
        </div>
      )}
      <ModalWrapper>
        <Modal ref={modalRef}>
          <div
            style={{
              padding: 32,
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 32,
              }}
            >
              <H3 style={{ padding: 0 }}>Wallet Mnemonic</H3>

              <button
                style={{
                  background: 'transparent',
                  border: 'none',
                  outline: 'none',
                  textTransform: 'uppercase',
                  cursor: 'pointer',
                }}
                type="button"
                onClick={() => {
                  if (modalRef.current) modalRef.current.close();
                }}
              >
                Close
              </button>
            </div>
            <Paragraph>
              To import your wallet, open the Bitcoin.com App &gt; Tap +Add &gt;
              Import Wallet &gt; Enter phrase or tap scan
            </Paragraph>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Paragraph
                align="center"
                style={{ padding: '0px 16px', fontWeight: 'bold' }}
              >
                {mnemonic}
              </Paragraph>
              <QRWrapper>
                <QRCode value={mnemonic} />
              </QRWrapper>
            </div>
            <Disclaimer>
              Do not share recovery phrase or QR with anyone or you are at risk
              of losing your funds
            </Disclaimer>
          </div>
        </Modal>
      </ModalWrapper>
    </>
  );
};

Wallets.propTypes = {
  wallets: PropTypes.shape({
    tombstoneWallets: PropTypes.arrayOf(PropTypes.string),
    version: PropTypes.string,
    wallets: PropTypes.arrayOf(
      PropTypes.shape({
        coin: PropTypes.string,
        derivationPath: PropTypes.string,
        mnemonic: PropTypes.string,
        walletId: PropTypes.string,
      }),
    ),
  }),
};

Wallets.defaultProps = {
  wallets: undefined,
};

export default Wallets;
